import { Component } from '@angular/core';
import {  AfterViewInit, AfterViewChecked, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';

declare var $: any;
@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  ngOnInit() {

  }

  ngAfterViewInit(): void {
    this.initializeSlick(); // Initialize slick for the first time
  }
  initializeSlick(): void {
    setTimeout(() => {
      $('.slider-user').not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
      });

      $('.slider-3_1').not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
      });
      // this.isSliderInitialized = true;
    }, 0); // Add timeout to allow the DOM to render
  }
}
